import { IconButton } from '@mui/material';
import React from 'react';
import { MdArrowBack } from 'react-icons/md';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  MainStyled,
  RootStyled,
  SubtitlePageStyled,
  TitlePageStyled,
} from './FormBaseScreen.styles';

// eslint-disable-next-line react/prop-types
export function FormBaseScreen({ pageName, construction, children }) {
  const navigate = useNavigate();
  const location = useLocation();

  function handleGoBack() {
    navigate(location.state?.from || '/admin');
  }

  return (
    <RootStyled>
      <IconButton
        onClick={() => handleGoBack()}
        style={{ margin: '40px 80px 0px 80px' }}
        size="large"
      >
        <MdArrowBack size={25} />
      </IconButton>
      <TitlePageStyled variant="h2">{pageName}</TitlePageStyled>
      <SubtitlePageStyled variant="h4">{construction}</SubtitlePageStyled>

      <MainStyled>{children}</MainStyled>
    </RootStyled>
  );
}
